<template>
  <div class="m-page-header-wrapper" :class="{ 'rtl--container': isArSite }">
    <div class="m-show-search" v-if="showSearch">
      <Search />
      <img class="icon-margin" src="@/assets/icon/m-close.svg" @click="onCloseSearch">
    </div>
    <div class="m-page-header" v-else>
      <div class="left">
        <img v-if="!showMenu && !showPersonalInfo" src="@/assets/icon/m-expand.svg" @click="onShowMenu">
        <img v-else src="@/assets/icon/m-close.svg" @click="onCloseMenu">
      </div>
      <div class="middle">
        <img class="logo" v-at-navigation="'main_menu::homepage'" :src="logoPic" @click="toMainPage">
      </div>
      <div class="right">
        <div v-if="languageList.length > 1" class="right-icon-box">
          <img v-show="!showLangMenu" src="@/assets/icon/m-site-language.svg" @click="onShowLangMenu">
          <img v-show="showLangMenu" src="@/assets/icon/m-close.svg" @click="onCloseLanguageMenu">
        </div>
        <div class="right-icon-box icon-margin">
          <img src="@/assets/icon/m-search.svg" @click="onShowSearch">
        </div>
      </div>
    </div>
    <!-- 下拉列表 -->
    <div v-show="showMenu || showLangMenu || showPersonalInfo" class="m-menu-wrapper" :class="{ 'rtl--container': isArSite }">
      <!-- 左侧菜单列表 -->
      <div v-if="showMenu" class="left-menu-wrapper">
        <MenuWithNonCerti v-if="showNonCertiMenu" @close="onCloseMenu" />
        <MenuWithoutNonCerti v-else @close="onCloseMenu" />
        <div v-if="!isLogin" class="m-menu-bottom" v-at-navigation="'main_menu::login'" @click="() => login()">
          <img src="@/assets/icon/m-logout-user.svg" style="margin-right: 0.8rem">
          {{ $t('header.signin') }} / {{ $t('header.login') }}
        </div>
        <div v-else class="m-menu-bottom m-menu-bottom-user-info" @click="onShowPersonalInfo">
          <div class="user-info-box">
            <img v-if="photoImgUrl" class="user-avatar" :src="photoImgUrl">
            <img v-else class="user-avatar" src="/image/header/user-default.png">
            <span class="username">{{ userName }}</span>
          </div>
          <img class="arrow-icon" src="/image/icon/up-linear.svg">
        </div>
      </div>
      <!-- 个人信息面板 -->
      <div v-else-if="showPersonalInfo" class="personal-info-wrapper">
        <div class="back-box" @click="onShowMenu">
          <img class="arrow-icon" src="/image/icon/up-linear.svg">
          {{ $t('global.back') }}
        </div>
        <div class="user-info-box">
          <img v-if="photoImgUrl" class="user-avatar" :src="photoImgUrl">
          <img v-else class="user-avatar" src="/image/header/user-default.png">
          <span class="username">{{ userName }}</span>
        </div>
        <div class="line-info-box" @click="onEditInfo">
          <img src="/image/header/setting.svg" class="line-info-icon">
          <span>{{ $t('header.personalInfo') }}</span>
        </div>
        <div class="line-info-box" @click="onLoginOut">
          <img src="/image/header/switchon.svg" class="line-info-icon">
          <span>{{ $t('header.logout') }}</span>
        </div>
      </div>
      <!-- 国家语言切换列表 -->
      <div v-else-if="showLangMenu" class="country-language-wrapper">
        <div class="language-selector-title">{{ $t('global.selectLanguage') }}</div>
        <div class="tips-wrapper">
          <img class="bulb-icon" src="/image/icon/tips-bulb.svg">
          <span>{{ $t('global.languageTips') }}</span>
        </div>
        <CountryLanguage :label="`Country`" v-model:value="country" @change="countryChange" :optionList="countryList" :option="{ label:'country', value: 'country' }" />
        <CountryLanguage :label="`Language`" v-model:value="languageId" :optionList="languageOption" :option="{ label:'languageComplete', value: 'id' }" />
        <div class="footer-botton">
          <Button @click="(e: Event) => onSubmit(e)">
              {{ $t('global.confirm') }}
          </Button>
        </div>
      </div>
    </div>
    <div class="m-language-tips" v-show="showLangTip">
    <div class="header" @click="onClose">
      <img src="@/assets/icon/close.svg">
    </div>
    <div class="content">
      <span>{{ $t('header.countryLanguageTips1') }} <span class="text">{{ `${country}/${language}` }}</span></span>
      <div>{{ $t('header.countryLanguageTips2') }} <span class="text" @click="onCountryLanguage">{{ $t('header.countryLanguageTips3') }}</span></div>
    </div>
  </div>
  </div>
</template>

<script lang="ts">
import { login, logout, toServerUrl, getTenantMap, CookieUtil } from '@/utils'
import { defineComponent, reactive, toRefs, watch, computed, onMounted } from 'vue'
import Search from './search.vue'
import { useStoreHooks } from '@/store/hook'
import { useRouter } from 'vue-router'
import { getAtModel, getLastNodeInUrl } from '@/utils/atModel'
import { LanguageItem } from '@/interface'
import { updateUserInfo } from '@/request/api/user'
import { useExamStatusHook } from '@/utils/moduleHooks/exam'
import { useHeaderHook } from '@/utils/moduleHooks/global'
import MenuWithNonCerti from './menuWithNonCerti.vue'
import MenuWithoutNonCerti from './menuWithoutNonCerti.vue'
import CountryLanguage from '@/components/form/select/select.vue'
import { Select } from 'ant-design-vue'
import { Button } from '@/components/common'
import { Modal } from '@/components/common'
import { useI18n } from 'vue-i18n'
export default defineComponent({
  components: {
    MenuWithNonCerti,
    MenuWithoutNonCerti,
    Search,
    CountryLanguage,
    Option: Select.Option,
    Button
  },
  emits: ['changeLayout'],
  setup (props, context) {
    const router = useRouter()
    const { getters, state: storeState } = useStoreHooks()
    const { emit } = context
    const { getLanguageSelectorVisible, getRelatedCertificationInfo } = useHeaderHook()
    const { checkUserInExam } = useExamStatusHook()
    const isArSite = computed(() => storeState.global.isArSite)
    const languageList = computed(() => storeState.global.languageList)
    const showNonCertiMenu = computed(() => storeState.global.showNonCertiMenu)
    const countryList = computed(() => storeState.global.countryList)
    const currentLangKey = computed(() => storeState.global.currentLangKey)
    const currentInfo = countryList.value.find(item => item.languageList.find(i => i.id === currentLangKey.value))
    const currentLanguageCountry = computed(() => {
      const index = storeState.global.currentLangKey
      const item = storeState.global.languageList.find(i => i?.id === index)
      return item || {} as LanguageItem
    })

    const { t } = useI18n()
    const state = reactive({
      showSearch: false,
      showMenu: false,
      showLangMenu: false,
      showPersonalInfo: false,
      expandedKeys: [] as string[],
      isLogin: getters['global/isLogin'],
      userName: storeState.global.userInfo?.name,
      photoImgUrl: storeState.global.userInfo?.photoImgUrl,
      country: currentInfo?.country || '',
      language: currentLanguageCountry.value.languageComplete,
      languageId: currentLangKey.value,
      languageOption: currentInfo?.languageList || [],
      showLangTip: false
    })
    const tenantId = computed(() => storeState.global.tenantId)
    const tenantMap = getTenantMap()

    const logoPic = computed(() => {
      const item = storeState.global.dictItemList.find(item => item.dictType === 'front_logo')
      return item ? item.dictLabel : ''
    })

    const closeAllMenu = () => {
      state.showMenu = false
      state.showLangMenu = false
      state.showPersonalInfo = false
      state.expandedKeys = []
    }

    const onCloseMenu = () => {
      closeAllMenu()
    }
    const onShowMenu = () => {
      closeAllMenu()
      state.showSearch = false
      state.showMenu = true
    }
    const onShowSearch = () => {
      closeAllMenu()
      state.showSearch = true
    }
    const onShowPersonalInfo = () => {
      closeAllMenu()
      state.showPersonalInfo = true
    }
    const onExpandMenu = (key: string) => {
      const index = state.expandedKeys.findIndex((k) => k === key)
      if (index < 0) {
        state.expandedKeys.push(key)
      } else {
        state.expandedKeys.splice(index, 1)
      }
    }
    const isExpand = (key: string): boolean => {
      return !!state.expandedKeys.includes(key)
    }
    const onCloseLanguageMenu = () => {
      CookieUtil.setCookie('languageCheckedId', currentLangKey.value + '', CookieUtil.FORMAT_TIME.YEAR)
      onCloseMenu()
    }
    const onShowLangMenu = () => {
      closeAllMenu()
      state.showLangMenu = true
    }
    const onCloseSearch = () => {
      state.showSearch = false
    }
    const toPage = (path: string, e?: Event) => {
      state.showMenu = false
      state.showPersonalInfo = false
      getAtModel().doNavigationEvent(`main_menu::${getLastNodeInUrl(path)}`, e)
      router.push(`/mobile${path}`)
    }
    const onEditInfo = () => {
      toPage('/my-learning/edit')
    }
    const toMainPage = () => {
      setTimeout(() => {
        toServerUrl('/', true)
      }, 500)
    }
        const onLoginOut = () => {
      // 用户在考试中时，阻止用户退出登陆
      if (checkUserInExam()) {
        return Modal.confirm({
          content: t('exam.logoutOnExam'),
          hideOkButton: true,
          cancelText: t('exam.back')
        })
      }
      if (tenantId.value === tenantMap.hikvision) {
        logout()
      } else if (tenantId.value === tenantMap.micro) {
        // 微影的登出
        logout()
      }
    }

    const countryChange = (val: any) => {
      const currentInfo = countryList.value.find((item) => item.country === val)
      state.languageOption = currentInfo?.languageList || []
      state.languageId = state.languageOption[0].id
      state.language = state.languageOption[0].languageComplete
    }

    const onSubmit = (e: Event) => {
      getAtModel().doActionEvent(`header::button::${state.language}`, e)
      CookieUtil.setCookie('languageCheckedId', state.languageId + '', CookieUtil.FORMAT_TIME.YEAR)
      if (state.isLogin) {
        const userInfo = {
          ...storeState.global.userInfo,
          languageId: state.languageId
        }
        updateUserInfo(userInfo).then(res => {
          if (res.code === 200) {
            location.href = `/${window.prefix}/`
          }
        }).finally(() => {
          getRelatedCertificationInfo(state.languageId as number)
        })
      } else {
        getRelatedCertificationInfo(state.languageId as number)
      }
    }
    const doLanguageChangeAction = (e: Event, langItem: LanguageItem) => {
      getAtModel().doActionEvent(`header::button::${langItem.languageComplete}`, e)
      CookieUtil.setCookie('languageCheckedId', langItem.id + '', CookieUtil.FORMAT_TIME.YEAR)
      if (state.isLogin) {
        const userInfo = {
          ...storeState.global.userInfo,
          languageId: langItem.id
        }
        updateUserInfo(userInfo).then(res => {
          if (res.code === 200) {
            location.href = `/${window.prefix}/`
          }
        }).finally(() => {
          getRelatedCertificationInfo(langItem.id)
        })
      } else {
        getRelatedCertificationInfo(langItem.id)
      }
    }
    const onCountryLanguage = () => {
      state.showLangMenu = true
      onClose()
    }
    const onClose = () => {
      state.showLangTip = false
      CookieUtil.setCookie('showCountryLanguageTips', 'true')
    }
    onMounted(() => {
      const visible = getLanguageSelectorVisible()
      state.showLangTip = visible
    })
    watch(() => [
      state.showMenu,
      state.showLangMenu
    ], (newValues: boolean[]) => {
      if (newValues.some(Boolean)) {
        emit('changeLayout', true)
      } else {
        emit('changeLayout', false)
      }
    })
    return {
      ...toRefs(state),
      onCloseMenu,
      onShowMenu,
      onShowSearch,
      onShowLangMenu,
      onCloseSearch,
      onCloseLanguageMenu,
      doLanguageChangeAction,
      toPage,
      toMainPage,
      onExpandMenu,
      isExpand,
      onLoginOut,
      onShowPersonalInfo,
      onEditInfo,
      tenantId,
      tenantMap,
      isArSite,
      logoPic,
      languageList,
      countryList,
      currentLangKey,
      currentLanguageCountry,
      showNonCertiMenu,
      onSubmit,
      countryChange,
      onCountryLanguage,
      onClose,
      login
    }
  }
})
</script>
<style lang="less" src="./index.less"></style>
